// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220607/js/" + chunkId + "." + {"44":"dec4b719","225":"7fca5b7b","481":"32a0464d","486":"42612a64","770":"9a22931d"}[chunkId] + ".0.44008942782811544.chunk.js";
};